/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
// import axios from "axios";

// import parse from "html-react-parser";

import '../../css/event220916_2.css';
// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
import moment from 'moment';
// import { isMobile } from "react-device-detect";
//import $ from 'jquery';
// import ReactPlayer from "react-player";
// import Slider from "react-slick";

// import Timer from "react-timer-wrapper";
// import Timecode from "react-timecode";

// import ItemBox from "../../components/aketo/ItemBox";

// import { now } from "lodash";

class Event2024_agf extends Component {
  state = {
    tabIndex: 0,
  };

  componentDidMount = () => {};
  changeTab = (tab) => {
    if (tab !== 2) {
      this.setState({
        tabIndex: tab,
      });
    } else {
      if (
        moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >=
        '2024-11-28 17:00:00'
      ) {
        this.setState({
          tabIndex: tab,
        });
      } else {
        alert('준비중입니다.');
      }
    }
  };
  render() {
    const { tabIndex } = this.state;
    const { imgUrl } = this.props;

    return (
      <Fragment>
        <div className="event_head">
          <h3>AGF2024</h3>
          <button type="button" className="btnClose">
            <img src={imgUrl + '/img/detail_img/close_1.png'} alt="닫기" />
          </button>
        </div>
        <div className="eventCon">
          <div className="event220916_2" style={{ color: '#fff' }}>
            <img src={'/img/event/event2024_agf/img_main.png'} />
          </div>
          <div>
            <span
              onClick={() => this.changeTab(0)}
              style={{ cursor: 'pointer' }}
            >
              <img
                src={
                  tabIndex === 0
                    ? '/img/event/event2024_agf/tab01_on.png'
                    : '/img/event/event2024_agf/tab01_off.png'
                }
                style={{ width: '33.33%', padding: 0, margin: 0 }}
              />
            </span>
            <span
              onClick={() => this.changeTab(1)}
              style={{ cursor: 'pointer' }}
            >
              <img
                src={
                  tabIndex === 1
                    ? '/img/event/event2024_agf/tab02_on.png'
                    : '/img/event/event2024_agf/tab02_off.png'
                }
                style={{ width: '33.33%', padding: 0, margin: 0 }}
              />
            </span>
            <span
              onClick={() => this.changeTab(2)}
              style={{ cursor: 'pointer' }}
            >
              <img
                src={
                  tabIndex === 2
                    ? '/img/event/event2024_agf/tab03_on.png'
                    : '/img/event/event2024_agf/tab03_off.png'
                }
                style={{ width: '33.33%', padding: 0, margin: 0 }}
              />
            </span>
          </div>

          {tabIndex === 0 ? (
            <Fragment>
              <div name="00_MD">
                <img
                  src={'/img/event/event2024_agf/Goods_Top.png'}
                  useMap="#image-map"
                />
              </div>
              <div>
                <a name="01_MD"></a>
                <img src={'/img/event/event2024_agf/MD_01_Holo.png'} />
              </div>
              <div>
                <a name="02_MD"></a>
                <img src={'/img/event/event2024_agf/MD_02_Stel.png'} />
              </div>
              <div>
                <a name="03_MD"></a>
                <img src={'/img/event/event2024_agf/MD_03_Blue.png'} />
              </div>
              <div>
                <a name="04_MD"></a>
                <img src={'/img/event/event2024_agf/MD_04_Meechu.png'} />
              </div>
              <div>
                <a name="05_MD"></a>
                <img src={'/img/event/event2024_agf/MD_05_Girls.png'} />
              </div>
              <div>
                <a name="06_MD"></a>
                <img src={'/img/event/event2024_agf/MD_06_Oshinoko.png'} />
              </div>
              <div>
                <a name="07_MD"></a>
                <img src={'/img/event/event2024_agf/MD_07_Proseka.png'} />
              </div>
              <div>
                <a name="08_MD"></a>
                <img src={'/img/event/event2024_agf/MD_08_Metaphor.png'} />
              </div>
              <div>
                <a name="09_MD"></a>
                <img src={'/img/event/event2024_agf/MD_09_Persona3.png'} />
              </div>
              <div>
                <a name="10_MD"></a>
                <img src={'/img/event/event2024_agf/MD_10_Persona5.png'} />
              </div>

              <map name="image-map">
                <area
                  target=""
                  alt="홀로라이브"
                  title="홀로라이브"
                  href="#01_MD"
                  coords="83,246,579,439"
                  shape="rect"
                />
                <area
                  target=""
                  alt="스틸라이브"
                  title="스틸라이브"
                  href="#02_MD"
                  coords="602,247,1097,442"
                  shape="rect"
                />
                <area
                  target=""
                  alt="블루아카이브"
                  title="블루아카이브"
                  href="#03_MD"
                  coords="1121,244,1617,442"
                  shape="rect"
                />
                <area
                  target=""
                  alt="미츄"
                  title="미츄"
                  href="#04_MD"
                  coords="83,463,579,658"
                  shape="rect"
                />
                <area
                  target=""
                  alt="걸즈밴즈크라이"
                  title="걸즈밴즈크라이"
                  href="#05_MD"
                  coords="599,465,1097,662"
                  shape="rect"
                />
                <area
                  target=""
                  alt="최애의아이"
                  title="최애의아이"
                  href="#06_MD"
                  coords="1120,463,1613,659"
                  shape="rect"
                />
                <area
                  target=""
                  alt="프로젝트세카이"
                  title="프로젝트세카이"
                  href="#07_MD"
                  coords="344,686,840,880"
                  shape="rect"
                />
                <area
                  target=""
                  alt="메타포"
                  title="메타포"
                  href="#08_MD"
                  coords="861,683,1354,874"
                  shape="rect"
                />
                <area
                  target=""
                  alt="p3"
                  title="p3"
                  href="#09_MD"
                  coords="341,901,837,1096"
                  shape="rect"
                />
                <area
                  target=""
                  alt="p5"
                  title="p5"
                  href="#10_MD"
                  coords="860,901,1356,1096"
                  shape="rect"
                />
              </map>
              {/* <map name="FPMap0">
                <area href="#01_MD" shape="rect" coords="122,227,601,430" />
                <area href="#02_MD" shape="rect" coords="609,232,1088,427" />
                <area href="#03_MD" shape="rect" coords="1096,234,1576,421" />
              </map> */}
            </Fragment>
          ) : tabIndex === 1 ? (
            <Fragment>
              <div name="00_CAFE">
                <img
                  src={'/img/event/event2024_agf/Cafe_Top.png'}
                  useMap="#image-map1"
                />
              </div>
              <div>
                <a name="01_CAFE"></a>
                <img src={'/img/event/event2024_agf/Cafe_01_Holo.png'} />
              </div>
              <div>
                <a name="02_CAFE"></a>
                <img src={'/img/event/event2024_agf/Cafe_02_Stel.png'} />
              </div>
              <div>
                <a name="03_CAFE"></a>
                <img src={'/img/event/event2024_agf/Cafe_03_Blue.png'} />
              </div>
              <div>
                <a name="04_CAFE"></a>
                <img src={'/img/event/event2024_agf/Cafe_04_Proseka.png'} />
              </div>

              <map name="image-map1">
                <area
                  target=""
                  alt="홀로라이브"
                  title="홀로라이브"
                  href="#01_CAFE"
                  coords="338,244,837,442"
                  shape="rect"
                />
                <area
                  target=""
                  alt="스틸라이브"
                  title="스틸라이브"
                  href="#02_CAFE"
                  coords="861,247,1357,441"
                  shape="rect"
                />
                <area
                  target=""
                  alt="블루아카이브"
                  title="블루아카이브"
                  href="#03_CAFE"
                  coords="341,468,837,663"
                  shape="rect"
                />
                <area
                  target=""
                  alt="프로젝트세카이"
                  title="프로젝트세카이"
                  href="#04_CAFE"
                  coords="857,466,1360,661"
                  shape="rect"
                />
              </map>
            </Fragment>
          ) : (
            <Fragment>
              <div name="00_FAN_MEET">
                <img
                  src={'/img/event/event2024_agf/Special_Top.png'}
                  useMap="#FPMap2"
                />
              </div>
              <div>
                <a name="01_FAN_MEET"></a>
                <img src={'/img/event/event2024_agf/Special.png'} />
              </div>
            </Fragment>
          )}
          <div>
            <img src="/img/event/event2024_agf/notice.png" />
          </div>
        </div>
        <div>
          <img src="/img/event/event2024_agf/notice.png" />
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Event2024_agf));
